import React, { memo, Fragment, useMemo, useState } from "react";
import "./AllApps.scss";
import LandingPageCard from "../LandingPageCard/LandingPageCard";
import AxiomModal from "__AxiomComponents/AxiomModal/AxiomModal";

function AllApps(props) {
  const { loading, apps, favouriteApps, favouriteApp, unfavouriteApp, appSettings, refreshTimesRes } = props;

  const [remarksModal, setRemarksModal] = useState(false)
  const [currentClickedRemark, setCurrentClickedRemark] = useState('')

  // const allApps = useMemo(() => {
  //   return apps.filter((d) => !favouriteApps.some((f) => f.name === d.name));
  // }, [favouriteApps, apps]);

  const {
    favouriteApplications,
    favouriteDashboards,
    allApplications,
    dashboardGroups
  } = useMemo(() => {
    const favouriteApplications = [];
    const favouriteDashboards = [];
    const allApplications = [];
    const dashboardGroups = {};
    favouriteApps.forEach((app) => {
      const isDashboard =
        Object.prototype.hasOwnProperty.call(
          app,
          "dashboardCategory"
        );
      if (isDashboard) {
        favouriteDashboards.push(app);
      } else {
        favouriteApplications.push(app);
      }
    });
    apps
      .filter(
        (app) =>
          !favouriteApps.some(
            (fav) => fav.name === app.name
          )
      )
      .forEach((app) => {
        const isDashboard =
          Object.prototype.hasOwnProperty.call(
            app,
            "dashboardCategory"
          );
        if (isDashboard) {
          const category =
            app.dashboardCategory || "Others";
          if (!dashboardGroups[category]) {
            dashboardGroups[category] = [];
          }
          dashboardGroups[category].push(app);
        } else {
          allApplications.push(app);
        }
      });
    return {
      favouriteApplications,
      favouriteDashboards,
      allApplications,
      dashboardGroups
    };
  }, [apps, favouriteApps]);

  const refreshMap = useMemo(() => {
    const map = {};
    (refreshTimesRes || []).forEach((item) => {
      map[item.dashboard_category] = item
    });
    return map
  }, [refreshTimesRes])


  const backgroundStyle = {};

  // if (appSettings && appSettings.dashboardBackground) {
  //   // backgroundStyle.backgroundImage = `url(${appSettings.dashboardBackground})`;
  //   backgroundStyle.backgroundSize = "cover";
  //   backgroundStyle.backgroundRepeat = "no-repeat";
  //   backgroundStyle.background = 'radial-gradient(circle at left top, rgba(95, 0, 253, 0.18) 0%, transparent 35%), radial-gradient(circle at right top, rgb(255 78 1 / 28%) 0%, transparent 40%), linear-gradient(rgb(245, 245, 245) 0%, rgb(238, 244, 255) 100%)';
  // }

  const formatRefreshTime = (date) => {
    if (!date) return "";
    const [datePart, timePart] = date.trim().split(" ");
    const [year, month, day] = datePart.split("-");
    const formattedDate = new Intl.DateTimeFormat("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    }).format(new Date(Number(year), Number(month) - 1, Number(day)));
    const [hour, minute] = timePart.split(":");
    const formattedTime = new Intl.DateTimeFormat("en-IN", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(
      new Date(2000, 0, 1, Number(hour), Number(minute))
    );
    return `${formattedDate}, ${formattedTime}`;
  };

  const showAppIcon = appSettings && appSettings.showAppIcon ? appSettings.showAppIcon : false;
  return (
    <div className="axiom-apps" style={backgroundStyle}>

      {/* <div className="dashboard-refresh-banner">
        <div className="dashboard-refresh-icon">
          ✓
        </div>
        <div className="dashboard-refresh-content">
          <div className="dashboard-refresh-title">
            Dashboards Refreshed Successfully
          </div>
          <div className="dashboard-refresh-subtitle">
            Latest dashboard refreshed and ready to use
          </div>
        </div>
        <div className="dashboard-refresh-time">
          Just now
        </div>
      </div> */}

      {favouriteApplications.length > 0 && (
        <Fragment>
          <h2 className="axiom-apps-section-title">{AxiomAPIs.translate("Favourite Apps")}</h2>
          <div className="axiom-apps-section">
            {favouriteApplications.map((app) => (
              <LandingPageCard
                key={app.name}
                app={app}
                favouriteAppFunction={unfavouriteApp}
                favApps={true}
                showAppIcon={showAppIcon}
              />
            ))}
          </div>
        </Fragment>
      )}
      {favouriteDashboards.length > 0 && (
        <Fragment>
          <h2 className="axiom-apps-section-title">
            {AxiomAPIs.translate("Favourite Dashboards")}
          </h2>
          <div className="axiom-apps-section">
            {favouriteDashboards.map((app) => (
              <LandingPageCard
                key={app.name}
                app={app}
                favouriteAppFunction={unfavouriteApp}
                favApps={true}
                showAppIcon={showAppIcon}
              />
            ))}
          </div>
        </Fragment>
      )}
      {allApplications.length > 0 && (
        <>
          <h2 className="axiom-apps-section-title">
            {AxiomAPIs.translate("Apps")}
            <span className="dashboard-count">
              {allApplications.length}
            </span>
          </h2>
          <div className="axiom-app-card-section">
            <div className="axiom-apps-section">
              {allApplications.map((app) => (
                <LandingPageCard
                  key={app.name}
                  app={app}
                  favouriteAppFunction={favouriteApp}
                  showAppIcon={showAppIcon}
                />
              ))}
            </div>
          </div>
        </>
      )}
      {Object.keys(dashboardGroups).length > 0 && (
        <>
          <h2 className="axiom-apps-section-title">
            {AxiomAPIs.translate("Dashboards")}
            <span className="dashboard-count">
              {Object.values(dashboardGroups).flat().length}
            </span>
          </h2>
          {Object.entries(dashboardGroups).map(([category, dashboards]) => {
            const refreshInfo = refreshMap[category];
            const hasDelay = Boolean(refreshInfo?.remarks?.trim());
            const refreshStatus = hasDelay ? "Refresh Delayed" : "Refreshed Successfully"
            return <div
              key={category}
              className="dashboard-category-container"
            >
              <div className="dashboard-category-header">
                <div className="dashboard-category-left">
                  <h3 className="dashboard-category-title">
                    {category}
                    <span className="dashboard-count">
                      {dashboards.length}
                    </span>
                  </h3>
                </div>
                {refreshInfo && (
                  <div className={`dashboard-refresh-banner ${hasDelay ? 'dashboard-refresh-banner-delayed' : ""}`}>
                    <div className={`dashboard-refresh-icon ${hasDelay ? 'delayed' : 'success'}`}>
                      {hasDelay ? "!" : "✓"}
                    </div>
                    <div className="dashboard-refresh-content">
                      <div className="dashboard-refresh-top">
                        <div className={`dashboard-refresh-status ${hasDelay ? "delayed" : "success"}`}>
                          {refreshStatus}
                        </div>
                        <div className="refresh-item">
                          <span className="refresh-label">Business Date</span>
                          <span className="refresh-value">
                            {refreshInfo.business_dt}
                          </span>
                        </div>
                        <div className="refresh-item">
                          <span className="refresh-label">Last Refresh</span>
                          <span className="refresh-value">
                            {formatRefreshTime(refreshInfo.refresh_datetime)}
                          </span>
                        </div>
                      </div>
                      {refreshInfo.remarks?.trim() && (
                        <div className="dashboard-refresh-note-inline">
                          <span className="dashboard-refresh-note-title">
                            Remarks:
                          </span>
                          <span
                            className="dashboard-refresh-note-text"
                            onClick={() => {
                              setRemarksModal(true);
                              setCurrentClickedRemark(refreshInfo.remarks);
                            }}
                          >
                            {refreshInfo.remarks}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>



              <div className="axiom-apps-section">
                {dashboards.map((dashboard) => (
                  <LandingPageCard
                    key={dashboard.name}
                    app={dashboard}
                    favouriteAppFunction={favouriteApp}
                    showAppIcon={showAppIcon}
                  />
                ))}
              </div>
            </div>
          })}
        </>
      )}
      {!loading &&
        allApplications.length === 0 &&
        favouriteApplications.length === 0 &&
        favouriteDashboards.length === 0 &&
        Object.keys(dashboardGroups).length === 0 && (
          <div className="axiom-apps-blank">
            You do not have access to any application. Please contact the platform administrator to
            get started.
          </div>
        )}
      {remarksModal && (
        <AxiomModal
          isOpen={remarksModal}
          onClose={() => setRemarksModal(false)}
        >
          <div className="dashboard-remarks-modal">
            <div className="dashboard-remarks-header">
              <div className="dashboard-remarks-icon">
                ℹ
              </div>
              <div>
                <div className="dashboard-remarks-title">
                  Refresh Delay Details
                </div>
                <div className="dashboard-remarks-subtitle">
                  Dashboard refresh information
                </div>
              </div>
            </div>
            <div className="dashboard-remarks-section">
              <div className="dashboard-remarks-body">
                {currentClickedRemark}
              </div>
            </div>
          </div>
        </AxiomModal>
      )}
    </div>
  );
}

export default memo(AllApps);
